var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3222 7.11553L2.47851 6.59718C2.30214 6.59102 2.17944 6.73388 2.17431 6.88085L3.61029 21.3808C3.60414 21.5572 3.747 21.6799 3.89396 21.685L14.8284 22.0669C15.0047 22.073 15.1274 21.9302 15.1326 21.7832L17.5765 7.41871C17.6404 7.27379 17.4986 7.12169 17.3222 7.11553Z",
    fill: "#FAFF29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4172 2.71057L12.6561 2.50938C12.6571 2.47999 12.6581 2.4506 12.6602 2.39181L12.6889 1.56879C12.7002 1.24546 12.4449 0.971681 12.1216 0.96039L8.12404 0.820794C7.80071 0.809503 7.52693 1.06481 7.51564 1.38814L7.4869 2.21115C7.48588 2.24055 7.48382 2.29933 7.4828 2.32873L1.69227 2.12652C1.5453 2.12139 1.45302 2.23588 1.44891 2.35346L1.35858 4.94009C1.35345 5.08705 1.46795 5.17934 1.58552 5.18345L18.3104 5.76749C18.4574 5.77263 18.5497 5.65813 18.5538 5.54056L18.6441 2.95393C18.6482 2.83635 18.5642 2.7157 18.4172 2.71057Z",
    fill: "#FAFF29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ebf54ed4aca2a08dbd69a3b1d435fab0.svg";
export { ForwardRef as ReactComponent };